import { Record } from 'immutable';
import { DEFAULT_KEY_ORDER } from 'commons-vehicle/constants/dataTypes.js';

const FeatureRecord = Record({
    code: '',
    description: '',
    dataTypeId: 0,
    typeIds: [],
    iconTypeCodes: [],
    isStandard: false,
    rank: DEFAULT_KEY_ORDER,
    isFromModelTrim: true,
    modelTrimRank: DEFAULT_KEY_ORDER,
});

class Feature extends FeatureRecord {}

export default Feature;
